import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG, MAX_LINKS_COUNT } from '../app-config.constants';
import { IAppConfig } from '../app-config.interface';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ObjectResponse} from '../classes/object-response';
import { HttpParams } from '@angular/common/http';
import {IInternalLinksResponse} from '../classes/interfaces';
import { Observable, of, empty } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import { ErrorService, ErrorKey } from './error.service';
import { CacheService } from './cache.service';
import { ListingCategory } from '../classes/enums';

@Injectable()
export class InternalLinksService {
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
              private http: HttpClient,
              private apiConfig: ApiConfigService,
              private errorService: ErrorService,
              private cache: CacheService
  ) { }

  getLinks(province: string, city?: string, listingCategory?: ListingCategory): Observable<IInternalLinksResponse> {

    const base = this.apiConfig.getServerRoot(this.appConfig.urls.internalLinks.base);
    const route = this.appConfig.urls.internalLinks.base;
    const params = this._setSearchParams(province, city, listingCategory);

    const hashKey = this.cache.getRequestHash(route, params);
    const hashValue = this.cache.get<IInternalLinksResponse | string>(hashKey, true);
    if (hashValue) {
      return of(typeof hashValue === 'string' ? JSON.parse(hashValue as string) : hashValue);
    }

    return this.http.get<ObjectResponse<IInternalLinksResponse>>(base + route, { params: params, withCredentials: true })
      .pipe(
        tap(res => this.cache.set(hashKey, res.result, 300)),
        map(res => res.result),
        catchError((error: HttpErrorResponse) => {
          this.errorService.displayError(ErrorKey.cms, error.error.errorCode, 12);
          return empty();
        })
      );
  }

  private _setSearchParams(province: string, city: string, listingCategory?: ListingCategory): HttpParams {
    let params = new HttpParams();
    params = params.append('linksRequest.LinkCount', MAX_LINKS_COUNT);

    if (province) {
      params = params.append('linksRequest.Province', province);
    }

    if (city) {
      params = params.append('linksRequest.City', city);
    }

    if (listingCategory) {
      params = params.append('linksRequest.ListingType', listingCategory.toString());
    }

    return params;
  }
}


